
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import OrdersScreen from "./Orders/OrdersScreens/OrdersScreen";
import PreparingItemsScreen from "./PreparingItems/PreparingItemsScreen";
import MenuPage from "./Menu/MenuPage";

function TabPanel(props) {
	const { children, value, index, ...other } = props;
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 2 }}>
					<Typography component="div">{children}</Typography>
				</Box>
			)}
		</div>
	);
}

function a11yProps(index) {
	return {
		id: `tab-${index}`,
		"aria-controls": `tabpanel-${index}`,
	};
}

const AdminMainPage = () => {
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Paper sx={{ p: 2 }}>
			<Tabs
				value={value}
				onChange={handleChange}
				variant="fullWidth"
				textColor="primary"
				indicatorColor="primary"
			>
				<Tab label="الطلبات" {...a11yProps(0)} />
				<Tab label="الطلبات قيد التجهيز" {...a11yProps(1)} />
				<Tab label="المنيو" {...a11yProps(2)} />
			</Tabs>

			<TabPanel value={value} index={0}>
				<OrdersScreen />
			</TabPanel>

			<TabPanel value={value} index={1}>
			<PreparingItemsScreen />
		</TabPanel>

			<TabPanel value={value} index={2}>
			<MenuPage />
			</TabPanel>
		</Paper>
	);
};

export default AdminMainPage;

